/* eslint-disable max-len */
/* eslint-disable max-lines */
import React from 'react';
import {Form, Grid} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import useClient from './customHooks/useClient';
import {formValidations} from '../../../constants/formValidations';
import {mapListToDropdownList} from '../../../utils/commonUtils';
import ButtonFloatClientFiles from '../../../../budgetVehicles/components/common/uploadFiles/buttonFloatClientFiles';
import './styles.scss';

const ClientForm = ({
  data,
  dataError,
  dealerId,
  exonerationsList,
  fetchAdviserList,
  handleChange,
  isUserTde,
  listDealers,
  cities,
  provinces,
  clientTypes,
  minValue,
  fetchFloatClientInfo,
  fetchFlInventoryAttachments,
  contTypesListCed,
  contTypesListRuc,
  contTypesListPass,
  setCurrentFloatingLine,
  currentLineOriginal,
  handleInputTextChange,
  isAvailable,
  passedSolNac,
}) => {
  const {
    'actions': {
      handleDocumentChange,
      handleClientTypeChange,
      handleDocumentRepChange,
    },
    'dataValues': {
      isSolNac,
      clientFilesKey,
      mappedClientTypes = [],
    },
  } = useClient({
    clientTypes,
    data,
    fetchAdviserList,
    listDealers,
    exonerationsList,
    dealerId,
    isUserTde,
    minValue,
    handleChange,
    formValidations,
    fetchFloatClientInfo,
    fetchFlInventoryAttachments,
    setCurrentFloatingLine,
    currentLineOriginal,
  });
  return (
    <>
      <Form size={'small'} autoComplete="off" className='form-floating-inventory'>
        <div className='W-100 floating-inv-section-title'>
          B. DATOS DEL CLIENTE
        </div>
        <Grid
          stackable
          fluid
          columns={3}
          divided
          className="no-space spacing-form-fl-inventory"
          textAlign="left"
        >
          <Grid.Column className='no-space-client-fl'>
            <Grid.Row>
              <Form.Select
                disabled={!isAvailable || passedSolNac}
                required
                fluid
                className='selector-tiny-size small-label-custom'
                label="TIPO DE CLIENTE"
                placeholder="SELECCIONE EL TIPO DE CLIENTE"
                name="clientType"
                value={data.clientType}
                options={mapListToDropdownList(
                  mappedClientTypes,
                  {
                    'keys': ['code'],
                    'values': ['code'],
                    'texts': ['description'],
                  }
                )}
                error={dataError.clientTypeError}
                onChange={(e, {name, value}) =>
                  handleClientTypeChange(name, value, formValidations.clientType(data))
                }
                onBlur={(e, {name, value}) =>
                  handleClientTypeChange(name, value, formValidations.clientType(data))
                }
              />
              <Form.Group
                grouped
                className="group-custom-floating" style={{'margin': '0px 0px 10px 0px'}}
              >
                <Form.Group inline widths={16} className='wrapper-fl-radio'>
                  {data.clientType &&
                    <label
                      className={
                        `field-client-custom small-label-custom-label ${(!isAvailable || passedSolNac) && 'floating-inventory-disabled'}`
                      }
                    >TIPO DE DOCUMENTO</label>
                  }
                  <div className="wrapper-fl-radio-document">
                    {data.clientType === '001' &&
                      <Form.Radio
                        disabled={!isAvailable || passedSolNac}
                        color='blue'
                        className='small-label-custom'
                        label="CI"
                        name="documentType"
                        value="C"
                        checked={data.documentType === 'C'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                      />}
                    {['002', '005'].includes(data.clientType) &&
                      <Form.Radio
                        disabled={!isAvailable || passedSolNac}
                        label="RUC"
                        className='small-label-custom'
                        name="documentType"
                        value="R"
                        checked={data.documentType === 'R'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                      />}
                    { data.clientType === '002' &&
                      <Form.Radio
                        disabled={!isAvailable || passedSolNac}
                        label="PASAPORTE"
                        className='small-label-custom'
                        name="documentType"
                        value="P"
                        checked={data.documentType === 'P'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                      />}
                  </div>
                </Form.Group>
                <Form.Group className='form-group-floating-id' style={{'marginBottom': '0px'}}>
                  <Form.Input
                    disabled={!isAvailable || passedSolNac}
                    required
                    className='small-label-custom'
                    width={12}
                    label='N° ID'
                    size='mini'
                    placeholder="EJ. 1805102074"
                    name="document"
                    value={data.document}
                    error={dataError.documentError}
                    onChange={(e, {name, value}) => handleInputTextChange(
                      e,
                      {name, value},
                      formValidations.document(data),
                    )}
                    onBlur={({'target': {name, value}}) => handleDocumentChange(
                      name,
                      value,
                      formValidations.document(data),
                    )}
                  />
                  {
                    data.id &&
                      <ButtonFloatClientFiles
                        code={clientFilesKey}
                        fileType={'clientId'}
                        title={'DOCUMENTOS DE IDENTIFICACIÓN'}
                        className='client-file-button-document'
                        disabled={!isAvailable || passedSolNac}
                      />
                  }
                </Form.Group>
              </Form.Group>
              {data.documentType !== 'R' &&
                <Form.Input
                  disabled={!isAvailable || passedSolNac}
                  className='small-label-custom'
                  required
                  size='mini'
                  label="NOMBRES"
                  placeholder="NOMBRES"
                  name="names"
                  value={data.names}
                  error={dataError.namesError}
                  onChange={(e, {name, value}) => handleInputTextChange(
                    e,
                    {name, value},
                    formValidations.names(data),
                  )}
                  onBlur={({'target': {name, value}}) =>
                    handleChange(name, value, formValidations.names(data))
                  }
                />
              }
              <Form.Input
                required
                disabled={!isAvailable || passedSolNac}
                className='small-label-custom'
                size='mini'
                label={data.documentType === 'R' ? 'RAZÓN SOCIAL' : 'APELLIDOS'}
                placeholder={data.documentType === 'R' ? 'RAZÓN SOCIAL' : 'APELLIDOS'}
                name="lastNames"
                value={data.lastNames}
                error={dataError.lastNamesError}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidations.lastNames(data),
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(name, value, formValidations.lastNames(data))
                }
              />
            </Grid.Row>
          </Grid.Column>
          <Grid.Column className='no-space-client-fl'>
            <Grid.Row className='fl-inventory-spacing-top'>
              {data.clientType === '001' && (
                <>
                  <Form.Group className='floating-inv-wrapper-one-line'>
                    <label
                      className={
                        `small-label-custom-label ${(!isAvailable || passedSolNac) && 'floating-inventory-disabled'}`}
                      style={{'fontWeight': 'bold'}}
                    >
                      % DE DISCAPACIDAD
                    </label>
                    <Form.Input
                      disabled={!isAvailable || passedSolNac}
                      className='small-label-custom'
                      size='mini'
                      required={data.clientType === '001'}
                      name="discapacityPerc"
                      value={data.discapacityPerc}
                      error={dataError.discapacityPercError}
                      onChange={(e, {name, value}) => handleInputTextChange(
                        e,
                        {name, value},
                        formValidations.discapacityPerc(data),
                        {minValue}
                      )}
                      onBlur={({'target': {name, value}}) =>
                        handleChange(
                          name,
                          value,
                          formValidations.discapacityPerc(data),
                          {minValue}
                        )
                      }
                    />
                  </Form.Group>

                </>
              )}
              <Form.Group className='floating-inv-wrapper-one-line'>
                <label className={
                  `small-label-custom-label ${(!isAvailable || passedSolNac) && 'floating-inventory-disabled'}`
                }
                style={{'fontWeight': 'bold'}}
                >
                  % DE EXONERACIÓN
                </label>
                <Form.Input
                  disabled={!isAvailable || passedSolNac}
                  className='small-label-custom'
                  readOnly
                  size='mini'
                  value={data.exonerationPerc}
                />

              </Form.Group>
              <Form.Group inline widths={16} className='no-space-check'>
                <label
                  className={
                    `field-client-custom small-label-custom-label ${(!isAvailable || passedSolNac) && 'floating-inventory-disabled'}`
                  }
                >
                  CERTIFICACIÓN DE VERIFICACIÓN
                </label>
                <Form.Checkbox
                  disabled={!isAvailable || passedSolNac}
                  name="certificate"
                  value={data.certificate}
                  checked={data.certificate === 'S'}
                  onChange={(e, {name, value}) => {
                    const valueToUpdate = value === 'S' ? 'N' : 'S';
                    handleChange(name, valueToUpdate, formValidations.certificate(data));
                  }}
                  error={dataError.certificateError}
                />
                {
                  data.id &&
                    <ButtonFloatClientFiles
                      code={clientFilesKey}
                      fileType={'infoCertification'}
                      title={'CERTIFICACIÓN DE VERIFICACIÓN DE LA INFORMACIÓN'}
                      disabled={!isAvailable || passedSolNac}
                    />
                }
              </Form.Group>
              <Form.Select
                disabled={!isAvailable || passedSolNac}
                required={isSolNac}
                fluid
                className='selector-tiny-size small-label-custom floating-client-mt-1'
                label="COD. CONTRIBUYENTE"
                placeholder="SELECCIONE EL CÓDIGO DE CONTRIBUYENTE"
                name="contributorCode"
                value={data.contributorCode}
                options={mapListToDropdownList(
                  data.documentType === 'P' ?
                    contTypesListPass :
                    (data.documentType === 'R' ? contTypesListRuc :
                      (data.documentType === 'C' ? contTypesListCed : [])
                    ),
                  {
                    'keys': ['code'],
                    'values': ['code'],
                    'texts': ['description'],
                  }
                )}
                error={dataError.contributorCodeError}
                onChange={(e, {name, value}) =>
                  handleChange(name, value, formValidations.contributorCode(data))
                }
                onBlur={(e, {name, value}) =>
                  handleChange(name, value, formValidations.contributorCode(data))
                }
              />
              <Form.Group grouped className="group-custom-floating no-space-group">
                <Form.Group inline widths={16} className='no-space-check'>
                  <label
                    className={
                      `small-label-custom-label ${(!isAvailable || passedSolNac) && 'floating-inventory-disabled'}`
                    }
                  >
                    REPRESENTANTE LEGAL:
                  </label>
                  <Form.Checkbox
                    disabled={!isAvailable || passedSolNac}
                    name="hasLegalRepresentative"
                    value={data.hasLegalRepresentative}
                    checked={data.hasLegalRepresentative === 'S'}
                    onChange={(e, {name, value}) => {
                      const valueToUpdate = value === 'S' ? 'N' : 'S';
                      handleChange(name, valueToUpdate);
                    }}
                  />
                </Form.Group>
                {data.hasLegalRepresentative === 'S' && (
                  <Form.Group grouped error={dataError.legalRepresentativeTypeError}>
                    <Form.Group inline widths={16} className='wrapper-client-radio'>
                      <label
                        className={
                          `field-client-custom small-label-custom-label ${(!isAvailable || passedSolNac) && 'floating-inventory-disabled'}`}
                      >
                        TIPO DE DOCUMENTO
                      </label>
                      <Form.Radio
                        disabled={!isAvailable || passedSolNac}
                        className='small-label-custom'
                        label="CI"
                        name="legalRepresentativeType"
                        value="C"
                        checked={data.legalRepresentativeType === 'C'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                      />
                      <Form.Radio
                        disabled={!isAvailable || passedSolNac}
                        className='small-label-custom'
                        label="RUC"
                        name="legalRepresentativeType"
                        value="R"
                        checked={data.legalRepresentativeType === 'R'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                        error={dataError.legalRepresentativeTypeError}
                      />
                      <Form.Radio
                        disabled={!isAvailable || passedSolNac}
                        className='small-label-custom'
                        label="PASAPORTE"
                        name="legalRepresentativeType"
                        value="P"
                        checked={data.legalRepresentativeType === 'P'}
                        onChange={(e, {name, value}) => handleChange(name, value)}
                      />
                    </Form.Group>
                    <Form.Input
                      disabled={!isAvailable || passedSolNac}
                      required={data.hasLegalRepresentative === 'S'}
                      className='small-label-custom floating-client-mt-2'
                      size='mini'
                      min={10}
                      max={15}
                      fluid
                      label="N° ID"
                      placeholder="Ej. 1805102074"
                      name="legalRepresentativeId"
                      value={data.legalRepresentativeId}
                      error={dataError.legalRepresentativeIdError}
                      onChange={(e, {name, value}) => handleInputTextChange(
                        e,
                        {name, value},
                        formValidations.legalRepresentativeId(data),
                      )}
                      onBlur={({'target': {name, value}}) => handleDocumentRepChange(
                        name,
                        value,
                        formValidations.legalRepresentativeId(data),
                      )}
                    />
                    <Form.Input
                      disabled={!isAvailable || passedSolNac}
                      required={data.hasLegalRepresentative === 'S'}
                      className='small-label-custom floating-client-mt-2'
                      size='mini'
                      label={data.legalRepresentativeType === 'R' ? 'RAZÓN SOCIAL' : 'NOMBRE COMPLETO'}
                      placeholder={data.legalRepresentativeType === 'R' ? 'RAZÓN SOCIAL' : 'APELLIDOS Y NOMBRES'}
                      name="legalRepresentativeName"
                      value={data.legalRepresentativeName}
                      error={dataError.legalRepresentativeNameError}
                      onChange={(e, {name, value}) => handleInputTextChange(
                        e,
                        {name, value},
                        formValidations.legalRepresentativeName(data),
                      )}
                      onBlur={({'target': {name, value}}) =>
                        handleChange(
                          name,
                          value,
                          formValidations.legalRepresentativeName(data),
                        )
                      }
                    />
                  </Form.Group>
                )}
              </Form.Group>
              {data.id &&
                <Form.Group inline>
                  <label
                    className={
                      `main small-label-custom-label ${(!isAvailable || passedSolNac) && 'floating-inventory-disabled'}`
                    }
                  >
                    OTROS ARCHIVOS
                  </label>
                  <ButtonFloatClientFiles
                    code={clientFilesKey}
                    fileType={'others'}
                    title={'OTROS ARCHIVOS'}
                    disabled={!isAvailable || passedSolNac}
                  />
                </Form.Group>
              }
            </Grid.Row>
          </Grid.Column>
          <Grid.Column className='no-space-client-fl'>
            <Grid.Row>
              <Form.Input
                disabled={!isAvailable || passedSolNac}
                className='small-label-custom'
                required={isSolNac}
                size='mini'
                label="TELÉFONO"
                placeholder="EJ. 0998880000"
                name="phoneNumber"
                value={data.phoneNumber}
                error={dataError.phoneNumberError}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidations.phoneNumber(data),
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(
                    name,
                    value,
                    formValidations.phoneNumber(data),
                  )
                }
              />
              <Form.Input
                disabled={!isAvailable || passedSolNac}
                required={isSolNac}
                className='small-label-custom'
                size='mini'
                label="EMAIL"
                placeholder="EJ. juan.perez@email.com"
                name="email"
                value={data.email}
                error={dataError.emailError}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidations.email(data),
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(name, value, formValidations.email(data))
                }
              />
              <Form.Input
                disabled={!isAvailable || passedSolNac}
                required={isSolNac}
                className='small-label-custom'
                size='mini'
                label="DIRECCIÓN"
                placeholder="Ej. Av. MANUEL CÓRDOVA GALARZA SN"
                name="location"
                value={data.location}
                error={dataError.locationError}
                onChange={(e, {name, value}) => handleInputTextChange(
                  e,
                  {name, value},
                  formValidations.location(data)
                )}
                onBlur={({'target': {name, value}}) =>
                  handleChange(name, value, formValidations.location(data))
                }
              />
              <Form.Select
                disabled={!isAvailable || passedSolNac}
                required={isSolNac}
                className='selector-tiny-size small-label-custom'
                label="CIUDAD"
                placeholder="SELECCIONE LA CIUDAD"
                name="city"
                value={data.city}
                search
                options={
                  mapListToDropdownList(
                    cities,
                    {
                      'keys': ['code'],
                      'values': ['code'],
                      'texts': ['description'],
                    }
                  )}
                error={dataError.cityError}
                onChange={(e, {name, value}) =>
                  handleChange(name, value, formValidations.city(data))
                }
                onBlur={(e, {name, value}) =>
                  handleChange(name, value, formValidations.city(data))
                }
              />
              <Form.Select
                disabled={!isAvailable || passedSolNac}
                required={isSolNac}
                className='selector-tiny-size small-label-custom'
                label="PROVINCIA"
                placeholder="SELECCIONE LA PROVINCIA"
                name="province"
                value={data.province}
                search
                options={
                  mapListToDropdownList(
                    provinces,
                    {
                      'keys': ['code'],
                      'values': ['code'],
                      'texts': ['description'],
                    }
                  )}
                error={dataError.provinceError}
                onChange={(e, {name, value}) =>
                  handleChange(name, value, formValidations.province(data))
                }
                onBlur={(e, {name, value}) =>
                  handleChange(name, value, formValidations.province(data))
                }
              />
              <Form.Input
                disabled={!isAvailable || passedSolNac}
                required={isSolNac}
                readOnly
                className='small-label-custom'
                size='mini'
                label="PAÍS"
                value={(isUserTde || data?.dealerReservation === dealerId) ? 'ECUADOR' : ''}
              />
            </Grid.Row>
          </Grid.Column>
        </Grid>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'listDealers': state.dealer.list,
    'isUserTde': state.session.isUserFromTDE,
    'dealerId': state.session.dealerId,
    'exonerationsList': state.exemptionManagment.list,
    'provinces': state.extraData.provinces,
    'cities': state.extraData.cities,
    'clientTypes': state.extraData.clientTypes,
    'minValue': state.exemptionManagment.minValue,
    'contTypesListCed': state.extraData.contTypesListCed,
    'contTypesListRuc': state.extraData.contTypesListRuc,
    'contTypesListPass': state.extraData.contTypesListPass,
    'listClients': [],
  };
};

const {
  fetchAdviserList,
  fetchFloatClientInfo,
  fetchFlInventoryAttachments,
  setCurrentFloatingLine,
} = Actions;

export default connect(mapStateToProps, {
  setCurrentFloatingLine,
  fetchAdviserList,
  fetchFloatClientInfo,
  fetchFlInventoryAttachments,
})(ClientForm);
